import { Routes } from '@angular/router';
import { AuthGuard } from '@auth0/auth0-angular';
import { CallbackPage } from './pages/callback/callback.page';
import { UnauthorizedComponent } from './pages/unauthorized/unauthorized.component';
import { AccessPage } from './pages/access/access.page';
import { TokensPage } from './pages/tokens/tokens.page';
import { TokenDetailPage } from './pages/token-detail/token-detail.page';
import { PlaygroundPage } from './pages/playground/playground.page';
import { DocsPage } from './pages/docs/docs.page';
import { LogsPage } from './pages/logs/logs.page';

export const routes: Routes = [
  { path: '', redirectTo: 'tokens', pathMatch: 'full' },
  { path: 'callback', component: CallbackPage },
  { path: 'unauthorized', component: UnauthorizedComponent },
  { path: 'access', component: AccessPage, canActivate: [AuthGuard] },
  // titleKey drives the app-shell-header hoisted into app.component's template — routes
  // without a titleKey (access, callback, unauthorized) intentionally render no header.
  { path: 'tokens', component: TokensPage, canActivate: [AuthGuard], data: { titleKey: 'tokens.title' } },
  { path: 'tokens/:id', component: TokenDetailPage, canActivate: [AuthGuard], data: { titleKey: 'tokenDetail.title' } },
  { path: 'playground', component: PlaygroundPage, canActivate: [AuthGuard], data: { titleKey: 'playground.title' } },
  { path: 'logs', component: LogsPage, canActivate: [AuthGuard], data: { titleKey: 'logs.title' } },
  { path: 'docs', component: DocsPage, canActivate: [AuthGuard], data: { titleKey: 'docs.title' } },
  { path: '**', redirectTo: 'tokens' },
];
